import '../stylesheets/tailwind';
const images = require.context('../images/', true)